export { cn } from "@norn/widget-renderer/primitives"

/** The first `n` hex characters of a hash, for display next to a copy affordance. */
export function shortHash(hash: string, n = 12): string {
  return hash.length > n ? hash.slice(0, n) : hash
}

export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value)
}

export function asString(value: unknown): string | undefined {
  return typeof value === "string" ? value : undefined
}

export function asArray(value: unknown): readonly unknown[] {
  return Array.isArray(value) ? value : []
}

/** `source_schema` → `Source schema`. */
export function humanize(id: string): string {
  const spaced = id.replace(/[_-]+/g, " ").replace(/([a-z])([A-Z])/g, "$1 $2").trim()
  return spaced.charAt(0).toUpperCase() + spaced.slice(1).toLowerCase()
}
